import React, {useEffect, useState} from 'react';
import {Tooltip, Area, Cell} from 'recharts';
import Chart from "react-apexcharts";

const indiaMapPath = `M125.8 11.3c-25.2 0-45.8 20.6-45.8 45.8 0 25.2 20.6 45.8 45.8 45.8 25.2 0 45.8-20.6 45.8-45.8 0-25.2-20.6-45.8-45.8-45.8z
M100.6 56.7c-6.7 0-12.1-5.4-12.1-12.1 0-6.7 5.4-12.1 12.1-12.1 6.7 0 12.1 5.4 12.1 12.1 0 6.7-5.4 12.1-12.1 12.1z
M151 56.7c-6.7 0-12.1-5.4-12.1-12.1 0-6.7 5.4-12.1 12.1-12.1 6.7 0 12.1 5.4 12.1 12.1 0 6.7-5.4 12.1-12.1 12.1z
M137.9 21.2c-11.7 0-21.2 9.5-21.2 21.2 0 11.7 9.5 21.2 21.2 21.2 11.7 0 21.2-9.5 21.2-21.2 0-11.7-9.5-21.2-21.2-21.2z
M78.8 87.5c3.3 0 6-2.7 6-6 0-3.3-2.7-6-6-6-3.3 0-6 2.7-6 6 0 3.3 2.7 6 6 6z
M173.2 87.5c3.3 0 6-2.7 6-6 0-3.3-2.7-6-6-6-3.3 0-6 2.7-6 6 0 3.3 2.7 6 6 6z
M110.2 138.3c-18.7 0-34 15.3-34 34 0 18.7 15.3 34 34 34 18.7 0 34-15.3 34-34 0-18.7-15.3-34-34-34z
M91.5 172.5c-3.3 0-6-2.7-6-6 0-3.3 2.7-6 6-6 3.3 0 6 2.7 6 6 0 3.3-2.7 6-6 6z
M`

const stateData = [
    { name: 'Maharashtra', value: 123 },
    { name: 'Karnataka', value: 456 },
    // ... data for other states
];

function IndiaChloroplethMap() {
    const [width, setWidth] = useState(window.innerWidth * 0.8); // Adjust width as needed

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth * 0.8);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const colorScale = ['#fff7f3', '#fee08b', '#fc8d59', '#d7301f']; // Color gradient

    const getColor = (value) => {
        const index = Math.floor(value / (Math.max(...stateData.map((d) => d.value)) / (colorScale.length - 1)));
        return colorScale[index];
    };

    return (
        <Chart width={width} height={400} data={stateData}>
            <Tooltip/>
            <Area
                dataKey="value"
                fill="none"
                stroke="#fff"
                strokeWidth={2}
                d={indiaMapPath}
            >
                {stateData.map((state) => (
                    <Cell key={state.name} fill={getColor(state.value)} stroke="#fff"/>
                ))}
            </Area>
        </Chart>
    );
}

export default IndiaChloroplethMap;